import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Ohio State Buckeyes"
    hasGenericVideo={true}
    teamId={teamIds['Ohio State Buckeyes']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Buckeyes.png"
  />
)
